export type dataTable = {
  id: string;
  code: string;
  description: string;
  unit: string;
  unitPrice: number;
  isActive: boolean;
  budgetCategory: {
    id: string;
    code: string;
    name: string;
    color?: string;
  };
  budgetCategoryId: string;
  actionBudgetItemsCount: number;
  usageCount: number;
  state: string;
  createdAt?: string;
  updatedAt?: string;
};

export type TableProps = {
  data?: {
    activeItems: dataTable[];
    inactiveItems: dataTable[];
  };
  onAddActiveBudgetItem: (id: string) => Promise<void>;
  onAddInactiveBudgetItem: (id: string) => Promise<void>;
};

export type SearchbarFilterTypes = (value: string) => void;

export const budgetItemsColumnNames = {
  code: {
    id: 'code',
    labelKey: 'tables:headers.code',
  },
  description: {
    id: 'description',
    labelKey: 'tables:headers.description',
  },
  unit: {
    id: 'unit',
    labelKey: 'tables:headers.unit',
  },
  unitPrice: {
    id: 'unitPrice',
    labelKey: 'tables:headers.unitPrice',
  },
  category: {
    id: 'category',
    labelKey: 'tables:headers.category',
  },
  usageCount: {
    id: 'usageCount',
    labelKey: 'tables:headers.usageCount',
  },
};
